module.exports = __webpack_public_path__ + "img/l-7.71143757.jpg";